// extracted by mini-css-extract-plugin
export default {"Country":"styles_Country__fObtA","isActive":"styles_isActive__1BMyP","name":"styles_name__GjZaa","code":"styles_code__LRZbU"};